import PropTypes from 'prop-types';
import React from 'react';
import StarRating from 'contest/components/star-rating';
import DesignAction from './connected/design-action';
import constants from 'contest/data/constants';

class RatingDesignAction extends React.Component {
    render() {
        if (this.props.design.status !== constants.DESIGN_STATUS_TYPES_VISIBLE) {
            return null;
        }

        const starVariations =
            this.props.activeUser && this.props.activeUser.isDesigner ? ['vibrant'] : [];

        return (
            <div className="design-actions-panel__action">
                <div
                    className="design-actions-panel__action__stars"
                    data-feature-tour-step-star-rating-block
                >
                    <StarRating
                        starVariations={starVariations}
                        isEditable={this.props.design.permission.canRate}
                        numSelectedStars={this.props.design.rating}
                        onChange={this.props.onUpdate}
                    />
                </div>
            </div>
        );
    }
}

RatingDesignAction.propTypes = {
    design: PropTypes.object.isRequired,
    activeUser: PropTypes.object,
    onUpdate: PropTypes.func.isRequired,
};

RatingDesignAction.defaultProps = {
    activeUser: null,
};

export default DesignAction(RatingDesignAction);



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/components/rating-design-action.jsx